import { ErrorHandling, useSnackbar  } from "@sagecentral/core-ui";
import { Notes, TaskLayout, TaskOverview, TaskPermissionsProvider } from "components/tasks";
import TaskOptionsProvider from "components/tasks/TaskOptionsProvider";
import { TaskAttachmentsGrid } from "components/tasks/attachments/grid";
import { Dependencies } from "components/tasks/dependencies";
import { TasksGrid } from "components/tasks/grid";
import TaskMetadata from "components/tasks/metadata";
import { ErrorHandlerProvider } from "hooks/shared";
import { Navigate, Route, Routes } from "react-router";

const TaskRoutes = () => {
    const { displaySnackbar } = useSnackbar();    
    const handler = async (resp: Response, error?: any) => {

        if (resp.status === 400) {
            const error = await resp.json();
            displaySnackbar('warning',error.errors['*'] ?? error.title??'Field update failed');

            return true;
        }   

        if(resp.status !== 403) return false;
        const message = await resp.text();
        displaySnackbar('error',message);
        return true;
    };
    return (
        <TaskPermissionsProvider>
            <TaskOptionsProvider>
                <ErrorHandlerProvider value={handler}>
                        <Routes>
                            <Route index element={<Navigate to="my/in-progress" replace={true} />} />
                            <Route path="inprogress" element={<Navigate to="../my/in-progress" replace={true} />} />
                            <Route path='my/'>
                            <Route index element={<Navigate to="in-progress" replace={true} />} />
                            <Route path="in-progress" element={<TasksGrid Status="in-progress" />} />
                            <Route path="upcoming" element={<TasksGrid Status="upcoming" />} />
                            <Route path="cancelled" element={<TasksGrid Status="cancelled" />} />
                            <Route path="onhold" element={<TasksGrid Status="on-hold" />} />
                            <Route path="on-hold" element={<TasksGrid Status="on-hold" />} />
                            <Route path="completed" element={<TasksGrid Status="completed" />} />
                            <Route path="all" element={<TasksGrid Status="all" />} />
                            <Route path="*" element={<ErrorHandling error={{ message: "Base error", name: "Error", cause: 404 }} />} />
                            </Route>
                            <Route path=":taskId" element={<TaskLayout />}>
                            <Route index element={<Navigate to="overview" replace={true} />} />
                            <Route path="overview" element={<TaskOverview />} />
                            <Route path="attachments" element={<TaskAttachmentsGrid />} />
                            <Route path="metadata" element={<TaskMetadata />} />
                            <Route path="notes" element={<Notes />} />
                            <Route path="dependencies" element={<Dependencies />} />
                            </Route>
                            <Route path="*" element={<ErrorHandling error={{ message: "Base error", name: "Error", cause: 404 }} />} />
                        </Routes>
                </ErrorHandlerProvider>
            </TaskOptionsProvider>
        </TaskPermissionsProvider>
    );
};

export default TaskRoutes;